module.exports = __webpack_public_path__ + "img/8-3.1ec7be61.jpg";